import './ui/styles.css';
import { config } from './app/config';
import { store } from './app/store';
import { createViewer, flyHome } from './app/viewer';
import { addQldImagery } from './imagery/qldImagery';
import { resolveTerrain } from './terrain/qldTerrain';
import { loadRailGeoJson } from './rail/railSource';
import { createRailFarLayer } from './rail/railLayer';
import { NearTrackManager } from './rail/lodManager';
import { MeasurementManager } from './measure/measurementManager';
import { mountOverlay } from './ui/overlay';

async function bootstrap(): Promise<void> {
  const viewer = createViewer();
  if (import.meta.env.DEV) {
    (window as unknown as Record<string, unknown>).__viewer = viewer;
  }

  // Terrain first so imagery drapes correctly and rail can sample heights.
  const { provider, path } = await resolveTerrain();
  viewer.terrainProvider = provider;
  store.set({ status: `terrain: ${path}` });

  await addQldImagery(viewer.scene);
  flyHome(viewer);

  const measure = new MeasurementManager(viewer);
  mountOverlay(measure);

  // Rail: far-LOD draped polylines + camera-driven near structure.
  let nearManager: NearTrackManager | undefined;
  try {
    const features = await loadRailGeoJson(`${config.rail.tilesUrl}/seq-sample.geojson`);
    const farLayer = createRailFarLayer(viewer.scene, features);
    nearManager = new NearTrackManager(viewer, features);
    nearManager.start();
    store.set({ status: `${store.get().status} · rail: ${features.length} segments` });

    // Layer toggle drives both LODs.
    store.subscribe((s) => {
      farLayer.show = s.layers.rail;
      nearManager?.setVisible(s.layers.rail);
    });
    if (import.meta.env.DEV) {
      (window as unknown as Record<string, unknown>).__railDebug = {
        farLayer,
        nearManager,
        features,
      };
    }
  } catch (err) {
    console.warn('[rail] no rail data loaded yet (run: npm run rail:tiles)', err);
    store.set({ status: `${store.get().status} · rail: none (run npm run rail:tiles)` });
  }

  document.getElementById('loading')?.classList.add('hidden');
}

bootstrap().catch((err) => {
  console.error('RailTwin failed to start', err);
  const el = document.getElementById('loading');
  if (el) el.textContent = 'Failed to start — see console.';
});
